export default "__VITE_ASSET__DhXI9rT2__";